function formatDate(date,str='-') {
    var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join(str);
}

//将一个数组分割成二维数组，可指定二维数组元素个数
function group(array, subGroupLength) {
    let index = 0;
    let newArray = [];
    while(index < array.length) {
      newArray.push(array.slice(index, index += subGroupLength));
    }
    return newArray;
}
//时分秒转秒
function toSecond(time) {
    var hour = time.split(':')[0]||0;
    var min = time.split(':')[1]||0;
    var sec = time.split(':')[2]||0;
    return Number(hour*3600) + Number(min*60) + Number(sec);
}
function compare(params) {
    return function (a,b) {
        var valuea=a[params]
        var valueb=b[params]
        if(valuea<valueb){
            return -1
        }else if(valuea>valueb){
            return 1
        }else{
            return 0
        }

    }
}
function timeCompared(time,timeList=[{beginTime:'06:30',endTime:'14:30'},{beginTime:'14:30',endTime:'22:30'},{beginTime:'22:30',endTime:'06:30'}],shiftList=['早班','中班','晚班']) {
    let num=0
    for(let i=0;i<timeList.length;i++){
        let item=timeList[i]
        if(i==(timeList.length-1)){
            if(toSecond(item.beginTime)<=toSecond(time)||toSecond(item.endTime)>toSecond(time)){
                num=i
                break ;
            }
        }else{
            if(toSecond(item.beginTime)<=toSecond(time)&&toSecond(item.endTime)>toSecond(time)) {
                num=i
                break ;
            }
        }
    }

    //return num===0?'早班':num===1?'中班':'晚班'
    return shiftList[num];
}
// 格式化日期
function intitime(time, fmt) {
  const that = time ? new Date(time) : new Date()
  var o = {
    'M+': that.getMonth() + 1, // 月份
    'd+': that.getDate(), // 日
    'H+': that.getHours(), // 小时
    'm+': that.getMinutes(), // 分
    's+': that.getSeconds(), // 秒
    'q+': Math.floor((that.getMonth() + 3) / 3), // 季度
    'S': that.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (that.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}
function  param2Obj(url) {
      const search = url.split('?')[1]
      if (!search) {
        return {}
      }
      const obj = {}
      const searchArr = search.split('&')
      searchArr.forEach(v => {
        const index = v.indexOf('=')
        if (index !== -1) {
          const name = v.substring(0, index)
          const val = v.substring(index + 1, v.length)
          obj[name] = val
        }
      })
      return obj
}
// 筛选月
function selectMonth(time) {
  time = time ? new Date(time) : new Date()
  let ym = intitime(time, 'yyyy-MM')
  var date = new Date(time);
  var year = date.getFullYear();
  var month = date.getMonth();
  var d = new Date(year, month + 1, 0);
  return [ym + '-01', ym + '-' + d.getDate()]
}
export {
    group,
    toSecond,
    timeCompared,
    compare,
    formatDate,
    intitime,
    selectMonth,
    param2Obj
}



// WEBPACK FOOTER //
// ./src/tool/index.js